import { render, staticRenderFns } from "./realtor.vue?vue&type=template&id=773d9bb9&scoped=true"
import script from "./realtor.vue?vue&type=script&lang=js"
export * from "./realtor.vue?vue&type=script&lang=js"
import style0 from "./realtor.vue?vue&type=style&index=0&id=773d9bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d9bb9",
  null
  
)

export default component.exports